import { isAudio } from '../../../../../lib/utils/mimeType';

function canPlay(mimeType: string): boolean {
  return isAudio(mimeType);
}

export default canPlay;
